// Common
import { ComponentRef, Directive, Input } from '@angular/core';

// Directives
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';

// Components
import { SidebarContextMenuComponent } from '@modules/contacts/components/sidebar-context-menu/sidebar-context-menu.component';

// Types
import { type ContactsRailKey, type ContactsRailScope } from '../components/sidebar-context-menu/contacts-rail-menu';

@Directive({
  selector: '[appSidebarContextMenu]',
  standalone: false,
})
export class SidebarContextMenuDirective extends ContextMenuDirective {
  // Inputs
  @Input() appSidebarContextMenu: ContactsRailKey;
  @Input() appSidebarContextMenuTenantId: string | null | undefined;
  /** A workspace rail row: the menu is the shared rail menu (`contacts-rail-menu.ts`). */
  @Input() public appSidebarContextMenuRail = false;
  /** Whether the row belongs to the member's My Workspace or to the Team Workspace. */
  @Input() public appSidebarContextMenuRailScope: ContactsRailScope = 'mine';

  registerComponent() {
    return SidebarContextMenuComponent;
  }

  registerInstance(componentRef: ComponentRef<SidebarContextMenuComponent>) {
    componentRef.instance.sidebarFilterKey = this.appSidebarContextMenu;
    componentRef.instance.railOrigin = this.elementRef.nativeElement;
    componentRef.instance.tenantId = this.appSidebarContextMenuTenantId;
    componentRef.instance.rail = this.appSidebarContextMenuRail;
    componentRef.instance.railScope = this.appSidebarContextMenuRailScope;
  }
}
